import { Box, Flex, Text } from '@chakra-ui/react';
import FsLightbox from 'fslightbox-react';
import { FC, useState } from 'react';
import { ReactComponent as AttachIcon } from 'assets/img/icons/attach.svg';
import { useTranslation } from 'react-i18next';
import { Color } from 'presentation/theme/colorScheme';
import useAppTheme from 'hooks/shared/useAppTheme';

interface Props {
  ruPhotos: string[];
  enPhotos: string[];
}

const HintScreenButton: FC<Props> = ({ ruPhotos, enPhotos }) => {
  const [toggler, setToggler] = useState(false);

  const { t, i18n } = useTranslation();

  const photos = i18n.language === 'ru' ? ruPhotos : enPhotos;

  const theme = useAppTheme();

  return (
    <>
      <Flex
        alignItems="center"
        onClick={() => setToggler(!toggler)}
        cursor="pointer"
      >
        <Box mr="10px">
          <AttachIcon fill={theme.colors[Color.Primary500]} width="15px" />
        </Box>
        <Text fontSize="14px" color={Color.Primary500}>
          {t('hintScreen')}
        </Text>
      </Flex>
      <FsLightbox
        toggler={toggler}
        sources={photos}
        sourceIndex={0}
        type="image"
        disableLocalStorage={false}
      />
    </>
  );
};

export default HintScreenButton;
